import React from 'react';
import { Link } from 'react-router-dom';

import Main from '../layouts/Main';

const Index = () => (
  <Main
    description={"CHENG  'JIAN's personal website. Shang Hai based ECNU Software Engineering graduate, "
    + 'Blockchain architect at alading, developer of Dodoca and IBM, and SE Alumni.'}
  >
    <article className="post" id="index">
      <header>
        <div className="title">
          <h2><Link to="/">About this site</Link></h2>
          <p>
            A beautiful, responsive, statically-generated,
            react application combined with AI and Blockchain tech.
          </p>
        </div>
      </header>
      <p> Welcome to my website. Please feel free to read more <Link to="/about">about me</Link>,
        or you can check out my {' '}
        <Link to="/resume">resume</Link>, {' '}
        <Link to="/projects">projects</Link>, {' '}
        view <Link to="/stats">site statistics</Link>, {' '}
        or <Link to="/contact">contact</Link> me.
      </p>
      <p> Here are some interesting AI games: <a href="http://118.89.72.19:8000" style={{ color: 'red' }}>Gesture Map</a>.</p>
      <p> Some algorithms Gesture Map deals with：<a href="https://en.wikipedia.org/wiki/Canny_edge_detector">  canny edge detection</a>、<a href="https://docs.opencv.org/3.1.0/d0/da5/tutorial_ximgproc_prediction.html"> Structured Forest edge detection</a>、<a href="https://imagej.net/Ridge_Detection"> ridge detection</a>、<a href="https://en.wikipedia.org/wiki/Vantage-point_tree"> Vantage-point tree</a>、<a href="https://stackoverflow.com/questions/19126994/what-is-the-cleanest-way-to-get-the-progress-of-jquery-ajax-request"> loading asynchronously</a>、<a href="https://www.webopedia.com/TERM/P/polyline.html"> polyline</a>...</p>
    </article>
  </Main>
);

export default Index;
